import { Link } from "react-router-dom";
import { SERVICES } from "../lib/content";
import { Reveal, MaskText, Line } from "../components/Motion";

export const ServicesPreview = () => (
  <section data-testid="services-preview" className="bg-paper py-24 md:py-40">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <div className="max-w-3xl mb-16 md:mb-24">
        <Reveal><p className="text-sand-deep text-[11px] uppercase tracking-[0.3em] mb-6">What I offer</p></Reveal>
        <MaskText as="h2" className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[0.95] text-ink" lines={["Ways to", "work together"]} />
      </div>

      <div className="space-y-0">
        {SERVICES.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.05}>
            <div className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-t border-ink/10 hover:border-ink/30 transition-colors duration-500">
              <div className="md:col-span-1"><span className="font-serif text-2xl text-sand-deep">{s.no}</span></div>
              <div className="md:col-span-4">
                <h3 className="font-serif text-3xl md:text-4xl text-ink group-hover:translate-x-2 transition-transform duration-500">{s.title}</h3>
              </div>
              <div className="md:col-span-5"><p className="text-ink-soft leading-relaxed">{s.desc}</p></div>
              <div className="md:col-span-2">
                <ul className="space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="text-sm text-ink-soft flex items-start gap-2">
                      <span className="text-sand-deep mt-1">—</span> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
        <Line />
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14">
          <Link to="/investment/" data-testid="services-investment-link" className="inline-flex items-center border border-ink text-ink text-[11px] uppercase tracking-[0.2em] px-7 py-4 rounded-full hover:bg-ink hover:text-paper transition-colors duration-500">
            See investment &amp; packages
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
